var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('Navbar',{attrs:{"cartQty":_vm.cartItems.length},on:{"toggle-cart":_vm.toggleCart}}),_c('router-view'),(_vm.isCartVisible)?_c('Cart',{attrs:{"cart-items":_vm.cartItems},on:{"close-cart":_vm.toggleCart}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }